import { API_ROOT } from '../../config/config'
import { doGet, doDownload, doPostDownload, doPost } from './utils'

// const API_ROOT = 'http://localhost:9014/api'

const API_ROOT_VER = `${API_ROOT}/v1/accounting`

export const getPaybookPage = (projectCode, period, pageNumber, pageSize) => {
  const url = `${API_ROOT}/v1/accounting/report/paybook/page/${projectCode}?period=${
    period || 0
  }&pageNumber=${pageNumber || 0}&pageSize=${pageSize || 0}`
  return doGet(url)
}

export const searchPaybookData = (projectCode, request) => {
  const url = `${API_ROOT}/v1/accounting/report/paybook/data/${projectCode}`
  return doPost(url, request)
}

export const ExportPaybookData = (projectCode, request) => {
  const url = `${API_ROOT}/files/download/accounting-paybook/${projectCode}`
  return doPostDownload(url, request)
}

export const getBorrowReportPage = (projectCode, period) => {
  const url = `${API_ROOT_VER}/report/borrow-avance/page/${projectCode}?period=${period || 0}`
  return doGet(url)
}

export const getBorrowReportPdf = (projectCode, period, startDate, endDate) => {
  // /api/files/{projectCode}/asset/borrow-avance/form
  // const API_ROOT = 'http://localhost:80/api'

  const url = `${API_ROOT}/files/${projectCode}/asset/borrow-avance/form?period=${period}&startDate=${startDate}&endDate=${endDate}`
  return doDownload(url)
}

export const downloadBorrowReportExport = (projectCode, period, startDate, endDate) => {
  const url = `${API_ROOT}/files/download/accounting-borrow-advance/${projectCode}?period=${
    period || 0
  }&startDate=${startDate}&endDate=${endDate}`
  return doDownload(url)
}

export const getSubProjecteReportPage = (projectCode, pagenumber, pagesize) => {
  const url = `${API_ROOT_VER}/report/subproject/page/${projectCode}?pageNumber=${
    pagenumber || 0
  }&pageSize=${pagesize || 0}`
  return doGet(url)
}

export const downloadSubProjecteReportExport = (projectCode) => {
  const url = `${API_ROOT}/files/download/accounting-subproject/${projectCode}`
  return doDownload(url)
}

export const downloadSubProjecteReportExportPdf = (mainProjectCode) => {
  // /api/files/{mainProjectCode}/accounting/accounting-subproject/file
  const url = `${API_ROOT}/files/${mainProjectCode}/accounting/accounting-subproject/file`
  return doDownload(url)
}

//Cash
export const callCashReport = (projectCode, request) => {
  // /api/v1/accounting/cash/search/{projectCode}
  const url = `${API_ROOT_VER}/cash/search/${projectCode}`
  return doPost(url, request)
}

export const downloadCashReportPdf = (projectCode, period, startDate, endDate) => {
  // ​/api​/files​/{projectCode}​/accounting​/cash/file
  const url = `${API_ROOT}/files/${projectCode}/accounting/cash/file?period=${
    period || ''
  }&startDate=${startDate}&endDate=${endDate}`
  return doDownload(url)
}

// Deposit
export const getExpenseRequestReport = (projectCode) => {
  // /api/v1/accounting/deposit/bank/{projectCode}
  const url = `${API_ROOT_VER}/deposit/bank/${projectCode}`
  return doGet(url)
}

export const calDepositReport = (projectCode, request) => {
  // /api/v1/accounting/deposit/search/{projectCode}
  const url = `${API_ROOT_VER}/deposit/search/${projectCode}`
  return doPost(url, request)
}

export const downloadDepositReportPdf = (projectCode, id, period, startDate, endDate) => {
  // /api/files/{projectCode}/accounting/deposit/file/{id}
  const url = `${API_ROOT}/files/${projectCode}/accounting/deposit/file/${id}?period=${
    period || ''
  }&startDate=${startDate}&endDate=${endDate}`
  return doDownload(url)
}

export const downloadPaybookPdf = (projectCode, request) => {
  const url = `${API_ROOT}/files/${projectCode}/account/paybook/form`
  return doPostDownload(url, request)
}
